/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import {IconName} from "@blueprintjs/icons"
import {Intent} from "@blueprintjs/core"
import {
    ToastType,
    showToast as showBCToast,
} from "../../@biocrates-common-repo/core/components/toast/AppToaster"
import store from "../../redux/store/store"

export interface ToastPropsWrapper {
    type?: ToastType
    message: string
    details?: string[]
    stacktrace?: string
    timeout?: number
    icon?: IconName
    intent?: Intent
    manualChapterAndId?: {first: string; second: string}
}

export const showToast = (
    {
        type = undefined,
        message,
        details = undefined,
        stacktrace = undefined,
        timeout = undefined,
        icon = undefined,
        intent = undefined,
        manualChapterAndId = undefined,
    }: ToastPropsWrapper,
    key: string = undefined
): string => {
    return showBCToast(
        {
            type,
            message,
            details,
            stacktrace,
            timeout,
            icon,
            intent,
            manualChapterAndId,
            dispatch: store.dispatch,
        },
        key
    )
}
